
import { motion, Variants } from 'framer-motion';

interface ArcProps {
    startX: number;
    startY: number;
    endX: number;
    endY: number;
    radius: number;
    variants: Variants;
    currentStep: string;
}

export const Arc = ({ startX, startY, endX, endY, radius, variants, currentStep }: ArcProps) => {
    return (
        <motion.path
            d={`M ${startX} ${startY} A ${radius} ${radius} 0 0 1 ${endX} ${endY}`}
            variants={variants}
            animate={currentStep}
            fill="none"
            strokeWidth="2"
        />
    );
};